import React, { useContext, useState } from "react";
import moment from "moment";
import { Link } from "@reach/router";
import parse from "html-react-parser";
import { S3_ENDPOINT, formatMonto } from "../../utils";
import { ProductsContext } from "../../context/ProductsContext";

const FlipCard = ({
  src,
  mode,
  link,
  title,
  subttitler,
  subtitle,
  priceNote,
  description,
  short_description,
}) => {
  const { products } = useContext(ProductsContext);
  const [flipped, setFlipped] = useState(false);

  const getPrice = () => {
    let minPrice;
    if (Array.isArray(products)) {
      const productsRender = [...products].filter(
        (product) => product.mode === mode,
      );
      productsRender.forEach((product) => {
        if (!minPrice) {
          minPrice =
            product.sale_price && product.sale_price !== null
              ? product.sale_price
              : product.price;
        } else if (product.price < minPrice) {
          minPrice = product.price;
        } else if (
          product.sale_price &&
          product.sale_price !== null &&
          product.sale_price < minPrice
        ) {
          minPrice = product.sale_price;
        }
      });
    }
    return minPrice;
  };

  const renderPriceInner = () => {
    const price = getPrice();
    const note =
      priceNote !== undefined
        ? priceNote
        : mode === "live"
          ? "planes de pago disponibles"
          : "";
    if (price) {
      return (
        <div className="my-3">
          <span className="m-auto d-block small">desde</span>
          <h4 className="futura h3 bold">${formatMonto(price)} MXN</h4>
          {note && <span className="m-auto d-block small">{note}</span>}
        </div>
      );
    }
  };

  const renderPrice = () => {
    const price = getPrice();
    const note =
      priceNote !== undefined
        ? priceNote
        : mode === "live"
          ? "planes de pago disponibles"
          : "";

    if (price) {
      return (
        <div className="flip-card-price-ribbon text-white text-center">
          <span className="d-block small">desde</span>
          <span className="h3" style={{ fontWeight: "700" }}>
            ${formatMonto(price)} MXN
          </span>
          {note && <span className="d-block small m-auto">{note}</span>}
        </div>
      );
    }
  };

  const renderDates = () => {
    if (Array.isArray(products)) {
      let productsRender = [...products].filter(
        (product) => product.mode === mode,
      );
      let minDate;
      let endDate;
      productsRender.forEach((product) => {
        if (product.start_date !== null) {
          if (!minDate) {
            minDate = product.start_date;
            endDate = product.end_date;
          } else if (moment(product.start_date).isBefore(minDate)) {
            minDate = product.start_date;
            endDate = product.end_date;
          }
        }
      });
      if (minDate && endDate) {
        return (
          <div>
            <p>Próximas Fechas</p>
            <p className="mb-0 bold text-primary ps-2">
              <i className="fa fa-calendar me-2"></i>{" "}
              {moment(minDate).utc().format("DD MMM YYYY")} -{" "}
              {moment(endDate).utc().format("DD MMM YYYY")}
            </p>
          </div>
        );
      }
    }
  };

  return (
    <div className={`card-container ${flipped ? "translated" : ""}`}>
      <div className="card-inner">
        <div className="card-front">
          <div
            className="text-center align-items-center text-white text-shadow border home-course relative"
            style={{
              backgroundImage: `url(${S3_ENDPOINT}/${src})`,
            }}
          >
            <div style={{ zIndex: 5 }} className="overlay"></div>
            <div className="row pb-5 px-0 align-items-center">
              <div style={{ zIndex: 10 }} className="container-fluid py-5 px-0">
                <h2 className="text-shadow position-relative h1 text-capitalize">
                  {title}
                </h2>
                <div className="w-75 m-auto">
                  <p className="francois fw-normal large">
                    {parse(short_description)}
                  </p>
                </div>
                <button
                  onClick={() => setFlipped(true)}
                  className="btn btn-round btn-light show-mobile shadow my-4"
                >
                  <i className="fa fa-chevron-right"></i>
                </button>
              </div>
              {renderPrice()}
            </div>
          </div>
        </div>
        <div className="card-back px-4 py-5 py-md-4 py-xl-5 bg-white shadow">
          <div className="container-fluid px-0 flip-card-back-content">
            <h3 className="h1 francois text-center text-capitalize">{title}</h3>
            {(subttitler || subtitle) && (
              <p className="francois fw-normal text-center mb-3">
                {subttitler || subtitle}
              </p>
            )}
            <p className="francois fw-normal large">{parse(description)}</p>
            {renderDates()}
            {renderPriceInner()}
            <Link to={link} className="btn btn-primary w-100 my-3">
              Ver certificaciones
            </Link>
            <button
              className="btn show-mobile py-0"
              onClick={() => setFlipped(false)}
            >
              Regresar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FlipCard;
